import * as angular from 'angular';
import { UserResourceTypes } from '@mode/shared/contract-common';

class reportDetailsCreatorController {
  authors: UserResourceTypes.UserResource[];
}

export const ID = 'reportDetailsCreator';

export const reportDetailsCreatorComponent: angular.IComponentOptions = {
  bindings: {
    creator: '<',
  },
  controller: reportDetailsCreatorController,
  controllerAs: 'ctrl',
  template: `
  <div class="report-details-author-container">
    <div class="creator-title">
      <h3 class="font-subtitle">Created By</h3>
    </div>
    <div class="creator-avatar">
      <img class="mode-avatar mode-icon-30"
        ng-if="ctrl.creator.avatar.type === 'uploaded' || ctrl.creator.avatar.type === 'gravatar'"
        alt="{{ ctrl.creator.name }}"
        title="{{ ctrl.creator.name }}"
        ng-src="{{ ctrl.creator.avatar.href }}">
      <div class="mode-avatar mode-avatar-initials mode-icon-30"
        ng-if="ctrl.creator.avatar.type === 'initials'"
        ng-class="[ctrl.creator.avatar.color_class]"
      >{{ ctrl.creator.avatar.initials }}</div>
      <span class="avatar-name">{{ ctrl.creator.name }}</span>
    </div>
  </div>`,
};
